"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var KUBERNETES_DATA = exports.KUBERNETES_DATA = "KUBERNETES_DATA";

var KUBERNETES_DELETE_POD = exports.KUBERNETES_DELETE_POD = "KUBERNETES_DELETE_POD";
//# sourceMappingURL=kubernetesConstants.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/kubernetes/kubernetesConstants.js
// module id = 249
// module chunks = 0